var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"83px"}},[_c('div',{staticClass:"TSDN-title"},[_vm._v("关于亚马逊TSPN")]),_c('div',{staticClass:"TSDN-content"},[_vm._v(" TSPN(Transparency Service Provider Network)即透明计划服务商网络，是亚马逊全球开店品牌保护团队（CNBPS）与服务商之间的中长期合作计划，旨在为卖家提供更好的品牌保护与成长方向的服务和体验。 对于加入TSPN的服务商，将能够获得亚马逊全球开店品牌保护团队提供一系列权益和资源支持，进而TSPN服务商可以帮助卖家开拓业务，提供更优质的服务。 ")])])])
}]

export { render, staticRenderFns }